import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import IconButton from "@mui/material/IconButton";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
// Limitless imports
import Tooltip from "../tooltip/Tooltip";
const iconVariants = {
  default: InfoOutlined,
  masked: InfoOutlined
};
const DialogueNote = ({
  classes,
  note,
  position
}) => {
  let Icon = iconVariants[note.action];
  Icon = Icon ? Icon : iconVariants["default"];
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: note.reason,
    customClass: position === "bottom-left" ? classes.bottomTooltip : position === "bottom-start" ? classes.bottomStartTooltip : classes.toolTip
  }, /*#__PURE__*/React.createElement(IconButton, {
    classes: {
      root: classes.iconButton
    },
    "aria-label": note.reason,
    disableTouchRipple: true,
    component: "div",
    size: "large"
  }, /*#__PURE__*/React.createElement(Icon, null)));
};
const styles = theme => {
  var _theme$palette$contra, _theme$palette, _theme$palette$contra2;
  return {
    toolTipWrapper: {
      zIndex: 53002
    },
    tooltipPlacementBottom: {
      margin: "4px, 0"
    },
    iconButton: {
      color: (_theme$palette$contra = (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$contra2 = _theme$palette.contrast) === null || _theme$palette$contra2 === void 0 ? void 0 : _theme$palette$contra2.text) !== null && _theme$palette$contra !== void 0 ? _theme$palette$contra : theme.palette.error.dark,
      padding: "2px"
    },
    toolTip: {
      "&:before": {
        top: "60%",
        height: "fit-content",
        left: 0,
        width: 150
      }
    },
    bottomTooltip: {
      "&:before": {
        top: "100%",
        height: "fit-content",
        left: -280,
        width: 300
      }
    },
    bottomStartTooltip: {
      "&:before": {
        top: "100%",
        left: 0,
        height: "fit-content",
        width: 300
      }
    }
  };
};
export default withStyles(styles)(DialogueNote);
DialogueNote.propTypes = {
  classes: PropTypes.object.isRequired,
  note: PropTypes.object.isRequired,
  position: PropTypes.string
};